// @flow

export const isLoading = state => state.requestFeedback.loading
export const getFeedbackList = state =>
  state.requestFeedback.data.results.objects
